namespace TabAurous.Inventory {
    export interface MRPRow {
        DetailsId?: number;
        TransId?: number;
        ProductId?: number;
        ProductCode?: string;
        UOM?: number;
        FixedCode?: string;
        AttributeId?: number;
        Minimum0?: number;
        Maximum0?: number;
        Minimum1?: number;
        Maximum1?: number;
        Minimum2?: number;
        Maximum2?: number;
        InStock?: number;
        InProcessQuantity?: number;
        DifferenceQuantity?: number;
        OrderQuantity?: number;
    }

    export namespace MRPRow {
        export const idProperty = 'DetailsId';
        export const localTextPrefix = 'Inventory.MRP';
        export const deletePermission = 'Inventory:MRP:Delete';
        export const insertPermission = 'Inventory:MRP:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:MRP:Edit';

        export declare const enum Fields {
            DetailsId = "DetailsId",
            TransId = "TransId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            UOM = "UOM",
            FixedCode = "FixedCode",
            AttributeId = "AttributeId",
            Minimum0 = "Minimum0",
            Maximum0 = "Maximum0",
            Minimum1 = "Minimum1",
            Maximum1 = "Maximum1",
            Minimum2 = "Minimum2",
            Maximum2 = "Maximum2",
            InStock = "InStock",
            InProcessQuantity = "InProcessQuantity",
            DifferenceQuantity = "DifferenceQuantity",
            OrderQuantity = "OrderQuantity"
        }
    }
}
